import createPalette from '../createPalette';

export default createPalette({});
